import { useCallback, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import TextInput from 'components/Common/Form/Input/TextInput'
import Modal from 'LuxKit/Modal/Modal'
import LineSearchIcon from 'LuxKit/Icons/line/LineSearchIcon'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import noop from 'lib/function/noop'
import type { TripPlannerChat } from 'tripPlanner/api/types'
import TripPlannerChatSearchResults from './TripPlannerChatSearchResults'

interface Props {
  recentChats?: Array<TripPlannerChat>
  onChatSelect: (chatId: number) => void
  onCloseReady?: (closeSearch: () => void) => void
}

export default function TripPlannerChatSearchModal({ recentChats, onChatSelect, onCloseReady }: Props) {
  const intl = useIntl()
  const { resolve } = useModalElementContext()
  const [query, setQuery] = useState('')

  useEffect(() => {
    onCloseReady?.(resolve)
    return () => onCloseReady?.(noop)
  }, [onCloseReady, resolve])

  const handleQueryChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(event.currentTarget.value)
  }, [])
  const handleChatSelect = useCallback((chatId: number) => {
    resolve()
    onChatSelect(chatId)
  }, [onChatSelect, resolve])

  const searchTitle = intl.formatMessage({
    id: 'vGLLJ_NNF92oG64yif5P',
    defaultMessage: 'Search chats',
    description: 'Title shown at the top of the TripPlanner chat search modal',
  })
  const searchPlaceholder = intl.formatMessage({
    id: 'UQZHv3OGmFyLWmnxKRSd',
    defaultMessage: 'Search chats…',
    description: 'Placeholder text shown in the TripPlanner chat search input',
  })
  return (
    <Modal
      title={searchTitle}
      size="S"
      height="auto"
      headerExtension={(
        <TextInput
          value={query}
          onChange={handleQueryChange}
          placeholder={searchPlaceholder}
          aria-label={searchTitle}
          startIcon={<LineSearchIcon />}
          autoFocus
          noValidationSpacing
        />
      )}
    >
      <TripPlannerChatSearchResults query={query} recentChats={recentChats} onChatSelect={handleChatSelect} />
    </Modal>
  )
}
